import { UserFacingError } from './errors'

export class PublicPageNotFoundError extends UserFacingError {
  constructor(message = 'This page is not available.') {
    super(message)
    this.name = 'PublicPageNotFoundError'
  }
}

export class EventRegistrationUnavailableError extends UserFacingError {
  constructor(
    message = 'This event is no longer taking registrations. Refresh the page for the latest.',
  ) {
    super(message)
    this.name = 'EventRegistrationUnavailableError'
  }
}

export class QrRateLimitedError extends UserFacingError {
  constructor(message = 'Too many attempts — try again later.') {
    super(message)
    this.name = 'QrRateLimitedError'
  }
}
